var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kn-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"tableTitle":"Productos","newButtonLabel":"Agregar producto","disableBtnCreate":!_vm.canAdd('product'),"paginationCount":_vm.pagination.lastPage,"hideDefaultFooter":true,"loading":_vm.loading},on:{"onChangePage":_vm.changePageProducts}})
}
var staticRenderFns = []

export { render, staticRenderFns }